export default {"src":"/_next/static/media/tomorrow-calendar-icon.5cfb977f.svg","height":24,"width":24};